<template>
  <v-list-item color="primary" :to="navigationItem.route" link>
    <v-badge
      inline
      :value="navigationItem.stat || 0"
      :content="navigationItem.stat"
      :color="badgeColor"
    >
      <v-list-item-title>
        {{ navigationItem.title }}
      </v-list-item-title>
    </v-badge>

    <v-list-item-icon>
      <v-icon>{{ navigationItem.icon }}</v-icon>
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
export default {
  name: "NavigationItemSingle",
  props: {
    navigationItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    badgeColor() {
      const { statColor } = this.navigationItem;
      if (statColor) return statColor;
      return "orange";
    },
  },
};
</script>

<style scoped></style>
